import { render, staticRenderFns } from "./jcBgList.vue?vue&type=template&id=4e8830ff&"
import script from "./jcBgList.vue?vue&type=script&lang=js&"
export * from "./jcBgList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports